import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SetComponentLanguage } from '../../../helpers';
import LocalizedStrings from 'react-localization';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import en from './locales/en.json';
import fr from './locales/fr.json';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class ConfirmEarlyPayoutModal extends Component {
    render() {
        return ( 
            <div>
                <Modal isOpen={this.props.isEarlyPayoutOpen} toggle={this.props.toggleConfirmEarlyPayout}>
                    <ModalHeader tag="h4" toggle={this.props.toggleConfirmEarlyPayout}>{strings.title}</ModalHeader>
                    
                    {!this.props.showEarlyPayoutConfirmation &&
                    <React.Fragment>
                        <ModalBody>
                            {strings.description}
                        </ModalBody>
                        <ModalFooter className="justify-content-center">
                            <button 
                                className="showtix-button showtix-background__grey-1"
                                onClick={this.props.toggleConfirmEarlyPayout}
                                >{strings.cancel}</button>
                            <button 
                                className="showtix-button showtix-background__primary-3"
                                onClick={this.props.confirmConfirmEarlyPayout}
                                >{strings.confirm}</button>    
                        </ModalFooter>
                    </React.Fragment>
                    }

                    {this.props.showEarlyPayoutConfirmation &&
                    <React.Fragment>
                        <ModalBody>
                            {strings.confirmationMsg}
                        </ModalBody>
                        <ModalFooter className="justify-content-center">
                            <button 
                                className="showtix-button showtix-background__grey-1"
                                onClick={this.props.toggleConfirmEarlyPayout}
                                >{strings.close}</button>   
                        </ModalFooter>
                    </React.Fragment>
                    }
                </Modal>
            </div>
        )
    }
}

export default ConfirmEarlyPayoutModal;


// WEBPACK FOOTER //
// ./src/components/EventListing/ConfirmEarlyPayoutModal/ConfirmEarlyPayoutModal.js